export const DEFAULT_GLOBAL_PATH = 'dataContract.settings';
